module.exports = __webpack_public_path__ + "img/img-event-tab-02.5ab6bf59.png";